import { Http } from '../../../support';
import ListItemHighlight from '../../../shared/support/ListItemHighlight';

const initialState = {
  busy: false,
  data: [],
  error: undefined,
  pagination: {
    limit: 25,
  },
  filters: {
    page: 1,
    search: '',
  },
};

const highlight = (store, data) => {
  const { data: recepcion } = store.state.modulo.recepcion.list;

  const tool = new ListItemHighlight(recepcion);

  store.setState((state) => {
    state.modulo.recepcion.list.data = tool.getNewList(data, true);
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.modulo.recepcion.list.busy = true;
  });

  try {
    const params = {
      limit: meta.limit || store.state.modulo.recepcion.list.pagination.limit,
      include: 'field',
      ...meta,
    };

    const response = await Http.get('api/recepciones', { params });

    store.setState((state) => {
      state.modulo.recepcion.list.busy = false;
      state.modulo.recepcion.list.data = response.data;
      state.modulo.recepcion.list.pagination = {
        ...state.modulo.recepcion.list.pagination,
        ...response.meta.pagination,
        ...meta,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.recepcion.list.error = error.data || error;
      state.modulo.recepcion.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.recepcion.list.error = undefined;
};

const reset = (store) => (state) => {
  state.modulo.recepcion.list = {
    ...initialState,
    pagination: {
      ...initialState.pagination,
    },
  };
};

const actions = {
  highlight,
  paginate,
  resetError,
  reset,
};

const RecepcionListStore = {
  state: () => ({
    ...initialState,
    pagination: {
      ...initialState.pagination,
    },
  }),
  actions,
};

export default RecepcionListStore;
